import React, { useContext, useEffect } from 'react';
import moment from 'moment';
import jwt from 'jsonwebtoken';
import Login from './Login';
import { AuthenticationContext } from './contexts/authentication-context';
import { refreshUserSession } from '../services/api';

require("babel-polyfill");

const PrivateRoute = (props) => {
    const { isUserAuthenticated, setIsUserAuthenticated } = useContext(AuthenticationContext)
  
    useEffect(() => {
        async function validateAuth() {
            let { idToken } = localStorage;
            if( !Boolean(idToken) ) {
                return setIsUserAuthenticated(false);
            }
            const { exp } = jwt.decode(idToken);
            const currentDayEpoch = moment().unix();
        
            if (exp <= currentDayEpoch) {
                try {
                    await refreshSession();
                    if (!Boolean(idToken)) return setIsUserAuthenticated(false)
                } catch(error) {
                    return setIsUserAuthenticated(false) ;
                }
            }
            
            return setIsUserAuthenticated(true) ;
        }

       validateAuth()
    }, [isUserAuthenticated])


    async function refreshSession () {
        const refreshToken = localStorage.getItem('refreshToken');
        const accessToken = localStorage.getItem("accessToken");

        try {
            const session = await refreshUserSession(refreshToken, accessToken);
            localStorage.setItem("idToken", session.idtoken);
            localStorage.setItem("accessToken", session.accessToken);
            localStorage.setItem("refreshToken", session.refreshToken);
            return;
        } catch (error) {
            throw error;
        };
    };

    const { as: Comp, children, ...newprops } = props;

    return isUserAuthenticated ? <Comp {...newprops}>{children}</Comp> : <Login path="/" setIsUserAuthenticated={setIsUserAuthenticated} />;
}

export default PrivateRoute